import React, { useState, useEffect } from 'react';
import { Col, Row, Table, Spin, Tooltip, notification, Popover } from 'antd';
import { BiSolidEdit } from "react-icons/bi";
import { Box, Stack } from '@mui/material';
import dayjs from 'dayjs';

import SearchInput from "../../components/uiComponent/inputs/searchinput/index";
import Select from "../../components/uiComponent/select/index";
import Button from "../../components/uiComponent/button/index";
import AgGrid from "../../components/ag-grid-table/index";
import Switch from '../../components/uiComponent/switch'
import Pagination from "../../components/pagination/index";
import Modal from "../../components/uiComponent/modal/index";
import Input from '../../components/uiComponent/inputs/input/index';
import XLSX from "xlsx";

import AmazonLogo from "../../assets/images/newImages/amazon-short-logo.svg";
import historyIcon from "../../assets/images/newImages/history-icon.svg";
import EditIcon from '../../assets/images/edit-icon.svg';
import infoIcon from '../../assets/images/newImages/baseline-info.svg';
import { GoUpload } from 'react-icons/go';
import ProductImg from "../../assets/images/newImages/nestle.svg";
import copyIcon from "../../assets/images/newImages/copy-white-icon.svg";
import { IoIosArrowDown } from "react-icons/io";


import InventoryWrapper from './style';
import { TableStyleWrapper } from './style';

import { copyToClip } from '../../utils/utils';
import { convertUtcToEst } from '../../utils/helpers';

import { AddUnitCost, GetVendorItems, ExportFilteredVendorItems } from '../../slices/3-layer-products';
import { GetVendorsList } from '../../slices/po'
import { EditVendorItemInfo } from '../../slices/vendor-items';
import { useSelector, useDispatch } from 'react-redux';
import { debounce, ceil, trim, sortBy as sort ,indexOf, isArray } from 'lodash';

const defaultColDef = {
  resizable: true,
  sortable: true,
  suppressMenu: true,
  suppressMovable: true,
};

const historyColumns = [
  {
    title: 'Po Name',
    dataIndex: 'po_name',
    key: 'po_name',
    render: (po_name, record) => {
      const { po_id } = record;
      if (po_id) {
        return <a href={`/po-details/${po_id}`}>{po_name}</a>;
      }
      return <span>{po_name || 'N/A'}</span>;
    },
  },
  {
    title: 'Unit Cost',
    dataIndex: 'unit_cost',
    key: 'unit_cost'
  },
  {
    title: 'Active Date',
    dataIndex: 'active_date',
    key: 'active_date',
    render: (active_date) => active_date ? dayjs(active_date).format('MM/DD/YYYY') : 'N/A'
  }
]

let gridApi;
let gridColumnApi
const VendorItems = () => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [showEditVendorItemModal, setShowEditVendorItemModal] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);
  const [costModal, setCostModal] = useState(false);
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', vendor_name: '' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [unitCost, setUnitCost] = useState(0);
  const [editedVendorItem, setEditedVendorItem] = useState({});
  const [openExport, setOpenExport] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);


  const {
    vendorItems,
    fetchingVendorItems,
    totalVendorItemsCount,
    addingUnitCost,
    exportingData
  } = useSelector((state) => state.threeLayerProducts || {});

  const { vendorsList } = useSelector((state) => state.pos || {})

  const {
    editVendorItemLoading,
  } = useSelector(state => state.vendorItems);

  useEffect(() => {
    dispatch(GetVendorItems({ page, filters }));
    dispatch(GetVendorsList())
  }, []);

  const padToEightDigits = (number) => {
    return number.toString().padStart(8, '0');
  }

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      width: 35,
      checkboxSelection: true,
      sortable: false,
      field: 'select'
    },
    {
      headerName: 'Vendor',
      sortable: false,
      filter: true,
      minWidth: 120,
      flex: 1,
      field: "vendors.name"
    },
    {
      headerName: 'Item ID',
      filter: true,
      sortable: false,
      minWidth: 135,
      flex: 1,
      field: "id",
      cellRenderer: ({ value }) => value ? padToEightDigits(value) : '-'
    },
    {
      headerName: 'Name',
      sortable: false,
      filter: true,
      minWidth: 120,
      flex: 1,
      field: "vendor_item_name",
      cellRenderer: ({ value }) => value || 'N/A'

    },
    {
      headerName: 'Brand',
      sortable: false,
      filter: true,
      minWidth: 120,
      flex: 1,
      field: "brand",
      cellRenderer: ({ data }) => {
        return (
          <>
            {data?.brand || data?.products_v2?.brand || 'N/A'}
          </>
        )
      }
    },
    {
      headerName: 'Identifier',
      sortable: false,
      filter: true,
      minWidth: 120,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { identifier_type, identifier_value, product } = data || {};
        const { identifier_type: prod_identifier_type } = product || {};

        return (
          <div className='title-wrapper'>
            <span>{(identifier_type || prod_identifier_type)?.toUpperCase() || ''}</span>
            <span className='upc-code'>{identifier_value || ''}</span>
          </div>
        )
      }
    },
    {
      headerName: 'Price',
      minWidth: 120,
      flex: 1,
      sortable: true,
      field: 'price', 
      cellRenderer: ({ data, node }) => {
        const { unit_cost_histories_v2 } = data || {};
        return (
          <div className='d-flex gap-3'>
            <div>
              ${unit_cost_histories_v2[0]?.unit_cost || 0}
            </div>
            <img src={historyIcon} alt='history' className='cursor-pointer' onClick={() => {
              setRowIndex(node.rowIndex);
              setShowModal(true);
            }} />
          </div>
        );
      }
    },
    {
      headerName: 'Case Qty',
      minWidth: 100,
      flex: 1,
      comparator: () => 0,
      field: 'case_quantity',
      cellRenderer: ({ value }) => value || 0

    },
    {
      headerName: 'MOQ',
      minWidth: 100,
      flex: 1,
      comparator: () => 0,
      field: 'minimum_order_quantity',
      cellRenderer: ({ value }) => value || 0
    },
    {
      headerName: 'Created',
      minWidth: 120,
      flex: 1,
      sortable: false,
      cellRenderer: ({ data }) => {
        const { unit_cost_histories_v2 } = data || {};
        const date = unit_cost_histories_v2[0]?.active_date ?
        new Date(unit_cost_histories_v2[0]?.active_date) : new Date();

        const datePart = convertUtcToEst(date, {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
        const timePart = convertUtcToEst(date, {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        });

        return (
          <div className='date-active'>
            <span>{datePart}</span>
            <span>({timePart})</span>
          </div>
        );
      }
    },
    {
      headerName: 'Action',
      sortable: false,
      minWidth: 76,
      maxWidth: 76,
      flex: 1,
      headerClass: 'ag-center-aligned-header',
      headerStyle: { textAlign: 'center' },
      cellRenderer: ({ node, data }) => {
        const {
          id,
          vendors,
          identifier_type,
          identifier_value,
          vendor_item_name,
          brand,
          case_quantity,
          minimum_order_quantity,
          products_v2
        } = data || {};
        const { name: vendor_name, id: vendor_id } = vendors || {};
        const { id: product_id } = products_v2 || {};

        return (
          <div className='d-flex align-items-center justify-content-center'>
            <BiSolidEdit style={{ color: '#1565D8' }} className='increase-font cursor-pointer'
              onClick={() => {
                setRowIndex(node.rowIndex);
                setShowEditVendorItemModal(true);
                setEditedVendorItem({
                  id,
                  vendor_name,
                  identifier_type,
                  identifier_value,
                  vendor_item_name,
                  brand: brand || products_v2?.brand, // if vendor item brand is not found then use product brand
                  case_quantity,
                  minimum_order_quantity,
                  product_id,
                  vendor_id
                });
              }}
            />
          </div>
        );
      }
    }
  ];

  const handleSearchProduct = debounce((value) => {
    if (trim(value) || filters.search) {
      setPage(page => ({ ...page, pageNumber: 1 }));
      setFilters({ search: value });
      dispatch(GetVendorItems({
        page: { ...page, pageNumber: 1 },
        filters: { ...filters, search: value },
        sortBy
      }));
    }
  }, 800);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetVendorItems({
      page: newPage,
      filters,
      sortBy
    }));
  };

  const refreshGridClick = () => {
    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true,
      });
      setSortBy({ key: '', type: '' })
    }
    dispatch(GetVendorItems({
      page,
      filters
    }))
  }
  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi
  };

  const handleExportAll = ()=>{
    dispatch(GetVendorItems({exportAll : true})).then(({payload})=>{
      if(payload.success == true){
        handleExportVendorItems(payload.result)
      }
    })
  }

  const handleExportFiltered = () => {
    const isFilterApplied = Object.values(filters).some(v => v !== '');

    if (!isFilterApplied) {
      notification.error({
        top: 65,
        message: 'Export Filtered',
        description: 'Please Select a Filter First'
      });
      return;
    }

    dispatch(ExportFilteredVendorItems({ filters, sortBy })).then(({ payload }) => {
      if (payload.success == true) {
        handleExportVendorItems(payload.result);
      }
    });
  };

  const handleExportVendorItems = (data) => {
    
    setOpenExport(false)
    let sortedSelectedRows;

    if (isArray(data)) {
        sortedSelectedRows = data; // Use data directly if it's an array
    } else {
        const selectedRows = selectedItems;
    
        if (selectedRows.length === 0) {
            notification.error({
                top: 65,
                message: 'Export SKU(s)',
                description: 'Please select at least one row to export.'
            });
            return;
        }
    
        sortedSelectedRows = sort(selectedRows, (item) => indexOf(vendorItems, item));
    }
    

    const mappedData = sortedSelectedRows?.map((Item) => {
      const {
        vendors,
        id,
        vendor_item_name,
        brand,
        identifier_type,
        identifier_value,
        unit_cost_histories_v2,
        case_quantity,
        minimum_order_quantity

      } = Item || {};

      return {
        'Vendor Name': vendors?.name || 'N/A',
        'Vendor Item ID': id,
        'Item Name': vendor_item_name || 'N/A',
        'Brand': brand || 'N/A',
        'Identifier Type': identifier_type?.toUpperCase() || 'N/A',
        'Identifier Value': identifier_value || 'N/A',
        'Price': unit_cost_histories_v2[0]?.unit_cost != null ? `$${unit_cost_histories_v2[0]?.unit_cost}` : `$0`,
        'Case Quantity': case_quantity || 0,
        'MOQ': minimum_order_quantity || 0,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vednor-Items");

    XLSX.writeFile(workbook, "VenderItem.xlsx");
  }
  useEffect(() => {
    if (gridApi && vendorItems?.length > 0) {
      gridApi.forEachNode((node) => {
        if (selectedItems.some(i => i.id === node.data.id)) {
          node.setSelected(true, false, true);
        }
      });
    }
  }, [vendorItems, gridApi]);

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null)

    if (value && ['minimum_order_quantity','case_quantity','price', 'id'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetVendorItems({
        page,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  }

  const { pageNumber, pageSize } = page || {};

  const tableDataSource = vendorItems[rowIndex]?.unit_cost_histories_v2
    ?.map((data) => ({ ...data, unit_cost: `$${data.unit_cost || 0}`, active_date: data.active_date?.split('T')[0], po_name: data.po_name }));

  const vendorStatuses = [
    { value: 'Enabled', label: 'Enabled', name: 'Enabled' },
    { value: 'Disabled', label: 'Disabled', name: 'Disabled' },
  ];

  const handleVendorStatusChange = (e) => {
    setFilters({ vendor_name: e?.value });
    dispatch(GetVendorItems({
      page,
      filters: { ...filters, vendor_name: e?.value }
    }));
  };

  const handleAddUnitCost = () => {
    dispatch(AddUnitCost({
      vendorItemId: vendorItems[rowIndex]?.id,
      unitCost
    })).then(({ payload }) => {
      if (payload?.success) {
        setCostModal(false);
        setUnitCost(0);
      }
    });
  };

  const handleEditVendorItem = (key, value) => {
    setEditedVendorItem((prev) => ({
      ...prev,
      [key]: value
    }))
  };

  const handleDisableVendorItem = () => {
    const { vendor_item_name, brand, minimum_order_quantity, case_quantity } = editedVendorItem;

    if (!vendor_item_name || !brand) return true;
    if (minimum_order_quantity && Number(minimum_order_quantity) < 1) return true;
    if (case_quantity && Number(case_quantity) < 1) return true;
    if (minimum_order_quantity != null && isNaN(Number(minimum_order_quantity) || (minimum_order_quantity != null && minimum_order_quantity < 1))) return true;
    if (case_quantity != null && isNaN(Number(case_quantity) || (case_quantity != null && case_quantity < 1))) return true;

    return false;
  };

  const data = vendorItems?.[rowIndex] || {};

  const handleVendorItem = () => {
    const body = {
      vendorItemId: editedVendorItem?.id,
      identifierType: editedVendorItem?.identifier_type,
      identifierValue: editedVendorItem?.identifier_value,
      productId: editedVendorItem?.product_id,
      vendorId: editedVendorItem.vendor_id,
      vendorItemName: editedVendorItem?.vendor_item_name,
      brand: editedVendorItem?.brand,
      moq: editedVendorItem?.minimum_order_quantity,
      caseQuantity: editedVendorItem?.case_quantity
    }
    dispatch(EditVendorItemInfo(body)).then(() => {
      setShowEditVendorItemModal(false);
      dispatch(GetVendorItems({ page, filters }));
    });
  }

  const onSelectionChange = () => {
    const currentPageSelected = gridApi?.getSelectedRows?.() || [];
    const currentPageAll = vendorItems || [];
    const currentPageAllIds = currentPageAll.map(i => i.id);

    setSelectedItems(prev => {
      const otherPagesSelected = prev.filter(i => !currentPageAllIds.includes(i.id));
      const newSelected = [...otherPagesSelected, ...currentPageSelected];
      setSelectedRowsCount(newSelected.length);
      return newSelected;
    });
  };

  const SelectExportType = ()=>{
    return (
      <InventoryWrapper className='mt-0'>
        <div className='items-menu'>
          <span onClick={() => handleExportVendorItems()}>Export Selected</span>
          <span onClick={handleExportFiltered}>Export Filtered</span>
          <span onClick={handleExportAll}>Export All</span>
        </div>
      </InventoryWrapper>
    )
    
  }
  const handleExportToggle = (e)=>{
    setOpenExport(!openExport)
    e.stopPropagation();
  }

  return (
    <InventoryWrapper>
      <div className='sku-bar'>
        <SearchInput
          placeholder="Search by Identifier / Item Name"
          width="264px"
          onChange={({ target }) => handleSearchProduct(target.value)}
        />
        <div style={{ display: 'flex', gap: '10px' }}>
          <Select
            isClearable={true}
            placeholder="Select Vendor"
            className="mb-0"
            width="200px"
            options={vendorsList}
            onChange={handleVendorStatusChange}
          />
          <Popover visible={openExport} overlayStyle={{ padding: 0 }} overlayClassName='dropdown-pop' trigger='click' Arrow={false} placement='bottom' title={null} content={<SelectExportType />}>
          <Spin size='small' spinning={exportingData}>
          <Button 
          disabled={!vendorItems?.length || exportingData}
           onClick={handleExportToggle} startIcon={<GoUpload style={{marginRight:'16px'}}/>} endIcon={<IoIosArrowDown />} className="outlined mb-0" text="Export" />
           </Spin>
          </Popover>
        </div>
      </div>
      <Spin tip='Loading...' spinning={fetchingVendorItems}>
        <AgGrid
          user_referrals={vendorItems}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          rowSelection="multiple"
          gridReady={gridReady}
          onSortChange={onSortChange}
          rowHeight={52}
          headerHeight={34}
          height="200px"
          onSelectionChanged={onSelectionChange}
          className="sku-table"
        />
      </Spin>
      <Pagination
        total={totalVendorItemsCount}
        totalPages={ceil(totalVendorItemsCount / pageSize + 1)}
        pageNumber={pageNumber}
        pageLimit={pageSize}
        handleLimitChange={(e) => handlePagination(e, 'pageSize')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
        isExport={true}
      />
      <Modal
        open={showModal}
        onHide={() => setShowModal(false)}
        header={true}
        closeButton={true}
        onClose={(e) => {
          e.preventDefault();
          setShowModal(false);
        }}
        onSave={() => setShowModal(false)}
      >
        <InventoryWrapper className='sku-modal mb-5'>
          <h4 className='cost-history fw-bold mb-3'>Unit Cost History</h4>
          <div className=''>
            <Table
              columns={historyColumns}
              dataSource={tableDataSource}
              pagination={false}
            />
          </div>
        </InventoryWrapper>
      </Modal>
      <Modal
        open={costModal}
        onHide={() => setCostModal(false)}
        header={true}
        closeButton={true}
        onClose={(e) => {
          e.preventDefault();
          setCostModal(false);
        }}
        onSave={() => setCostModal(false)}
      >
        <InventoryWrapper className='mb-5 pt-0'>
          <Spin tip='Loading...' spinning={addingUnitCost}>
            <h4 className='fw-bold mb-3'>Unit Cost History</h4>
            <Row gutter={12}>
              <Col span={19}>
                <Input
                  placeholder='Enter'
                  label='Price'
                  value={unitCost || ''}
                  marginBottom="0"
                  onChange={({ target }) => setUnitCost(target?.value)}
                />
              </Col>
              <Col span={5}>
                <div className="history-btn">
                  <Button
                    text="Submit"
                    className="mb-0"
                    onClick={handleAddUnitCost}
                    disabled={addingUnitCost}
                  />
                </div>
              </Col>
            </Row>
          </Spin>
        </InventoryWrapper>
      </Modal>

      <Modal
        open={showEditVendorItemModal}
        onHide={() => {
          setShowEditVendorItemModal(false);
        }}
        closeText="Cancel"
        saveText={editVendorItemLoading ? 'Saving..' : 'Save'}
        className="vendor-modal-wrapper-ui"
        header={true}
        buttonDisabled={handleDisableVendorItem() || editVendorItemLoading}
        removeIcon
        closeButton={false}
        onClose={() => {
          setShowEditVendorItemModal(false);
        }}
        onSave={() => {
          handleVendorItem();
        }}
      >
        <TableStyleWrapper>
          <div className="card-item-wrapper">
            <h6>Edit Vendor Item</h6>
            <div className="product-title">
              <img src={data?.products_v2?.image_url || ProductImg} alt="product" width={28} height={28} className='product-img' />
              <div className='w-100'>
                <Tooltip placement="bottom" title={data?.products_v2?.name || 'N/A'}>
                  <span className="product-name">{data?.products_v2?.name || 'N/A'}</span>
                </Tooltip>
                <div className='d-flex align-items-center gap-2'>
                  <div className='asin sku'>
                    <span>{data?.identifier_type || 'N/A'} <span>{data?.identifier_value || 'N/A'}</span></span>
                    <img src={copyIcon} alt='copy' className='cursor-pointer'
                      onClick={() => copyToClip(data?.identifier_value)} />
                  </div>
                </div>
              </div>
            </div>
            <Box>
              <Stack marginTop={1.5} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Vendor"
                  overlayClassName="input-vendor-add"
                  disabled
                  placeholder={editedVendorItem?.vendor_name || 'VendorName'}
                  value={editedVendorItem?.vendor_name || 'VendorName'}
                />
                <Input
                  label="Identifier"
                  overlayClassName="input-vendor-add"
                  disabled
                  placeholder={editedVendorItem?.identifier_type?.toUpperCase() || ''}
                  value={editedVendorItem?.identifier_type?.toUpperCase() || ''}
                />
              </Stack>
              <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Identifier Value"
                  overlayClassName="input-vendor-add"
                  disabled
                  placeholder={editedVendorItem?.identifier_value || 'N/A'}
                  value={editedVendorItem?.identifier_value || 'N/A'}
                />
                <Input
                  label="Item Name"
                  important
                  overlayClassName="input-vendor-add"
                  placeholder={editedVendorItem?.vendor_item_name || 'Enter'}
                  value={editedVendorItem?.vendor_item_name || ''}
                  onChange={(e) => {
                    handleEditVendorItem('vendor_item_name', e.target.value)
                  }}
                />
              </Stack>
              <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Brand"
                  important
                  overlayClassName="input-vendor-add"
                  placeholder={editedVendorItem?.brand || 'Enter'}
                  value={editedVendorItem?.brand || ''}
                  onChange={(e) => handleEditVendorItem('brand', e.target.value)}
                />
                <Input
                  label="MOQ (Minimum Order Qty)"
                  overlayClassName="input-vendor-add"
                  type='number'
                  placeholder={editedVendorItem?.minimum_order_quantity || 'Enter'}
                  value={editedVendorItem?.minimum_order_quantity || ''}
                  onChange={(e) => handleEditVendorItem('minimum_order_quantity', e.target.value)}

                />
              </Stack>
              <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Case Qty"
                  type='number'
                  overlayClassName="input-vendor-add"
                  placeholder={editedVendorItem?.case_quantity || 'Enter'}
                  value={editedVendorItem?.case_quantity || ''}
                  onChange={(e) => handleEditVendorItem('case_quantity', e.target.value)}
                />
              </Stack>
            </Box>
          </div>
        </TableStyleWrapper>
      </Modal>

    </InventoryWrapper>
  )
}

export default VendorItems;
